import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Configuration } from '../../constants/config';

/*
  Generated class for the CategoryServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CategoryServiceProvider {

    private ServerWithApiUrl: string;

    constructor(public http: Http, _configuration: Configuration) {
        this.ServerWithApiUrl = _configuration.ServerWithApiUrl;
    }

    /**
     * @Info Get Category list
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    getList(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Category/readCategory', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }


    /**
     * @Info Create Category
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    create(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Category/createCategory', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }


    /**
     * @Info Update Category
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    update(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Category/updateCategory', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }


    /**
     * @Info Delete Category
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-21
     */
    delete(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Category/deleteCategory', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }

}


// WEBPACK FOOTER //
// ./src/providers/category-service/category-service.ts